import React from 'react'
const CreateForm = React.lazy(() => import('./components/tokenManagement/ManageToken'))

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))
const Tokens = React.lazy(() => import('./views/base/tokens/Tokens'))
const AddToken = React.lazy(() => import('./components/tokenManagement/ManageToken'))
const Login = React.lazy(() => import('./views/pages/login/Login'));



const routes = [
  { path: '/', exact: true, name: '' },
  // { path: '/', name: 'Login', element: Login },

  { path: '/dashboard', name: 'Dashboard', element: Dashboard },
 
  { path: '/tokens', name: 'Tokens', element: Tokens },
  { path: '/tokens/add', name: 'Add Token', element: AddToken},
  { path: '/tokens/edit', name: 'Update Token', element: AddToken },
  

  {/* // { path: '/forms/form-control', name: 'Form Control', element: CreateForm },
  // { path: "/addToken", name: "CreateToken", element: CreateForm} */}
]

export default routes
